import React, { useState, useEffect } from 'react';
import apiUrl from '../Apiurl';
import prodVuoto from '../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';


function DatoModificabileInLinea(props) {

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    // componente di testo editabile con minitasto submit che va a patchare il relativo valore nel documento del db

    const idDocumento = props.idDocumento // per sapere che documento modificare, in teoria andrebbe sostituito con l'id
    const dato = props.dato; // es. Dolomite
    const nomeDato = props.nomeDato; // es. Brand

    const setProductFunction = props.setProductFunction;

    const classiTastoVerde = "f6 f5-l button-reset fl pv3 tc bn bg-animate tastoVerde hover-bg-black white pointer br2-ns br--right-ns"
    const classiTastoRosso = "f6 f5-l button-reset fl pv3 tc bn bg-animate tastoArancio hover-bg-black white pointer br2-ns br--right-ns"


    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);
    
    const [classeTasto, setClasseTasto] = useState(classiTastoVerde);

    const [valoreDato, setValoreDato] = useState(dato);

    function handleChange(evt) {
        const value = evt.target.value;
        setClasseTasto(classiTastoRosso);
        setValoreDato(value);
    }

    const reqUrl = apiUrl+"/prodotti/patch/datoDoc/"+idDocumento+"/"+nomeDato+"/"+valoreDato

    function patchDatoFunction(e) {
        fetch(reqUrl, {method: 'PATCH', headers: {'Authorization': 'Bearer '+token}} )
        .then(resp => resp.json())
        .then(data => setProductFunction(data[0] || prodVuoto))
        .then(e.preventDefault())     
        setClasseTasto(classiTastoVerde);
    }


    return(
        
            <form className='flex datoModificabileInLinea'>
                {/* <label for={nomeDato}>{nomeDato}</label><br /> */}
                <input
                    type="text"
                    id={nomeDato}
                    name={nomeDato}
                    value={valoreDato}
                    onChange={handleChange}
                    autoComplete="off"
                    className="input-reset bn fl black-80 sfondoBiancoTema pa3"
                />
                <button
                    type="button"
                    className={classeTasto+' datoModificabileInLineaTasto'}
                    onClick={patchDatoFunction}
                >&#9745;</button>
            </form>
    )
}


export default DatoModificabileInLinea;



